<div class="w-full h-full flex flex-col gap-3 items-center justify-center">
  @if (document().fileType.startsWith('LMA_')) {
    <app-document-lma-embed
      [documentID]="document().id"
      [organizationID]="organizationID()"
      class="w-full h-full"
    />
  } @else if (document().mimeType.startsWith('image/')) {
    <img
      [src]="document().id | fileSignedUrl: organizationID()"
      [attr.alt]="document().filename"
      class="max-w-full max-h-full object-contain"
    />
  } @else if (document().mimeType.startsWith('audio/')) {
    <audio class="w-full" controls [src]="document().id | fileSignedUrl: organizationID()"></audio>
  } @else if (document().mimeType.startsWith('video/')) {
    <video
      [src]="document().id | fileSignedUrl: organizationID()"
      controls
      class="w-full h-full"
    ></video>
  } @else if (
    document().mimeType.startsWith('text/plain') || document().mimeType === 'application/json'
  ) {
    <app-document-text
      class="w-full h-full"
      [document]="document()"
      [organizationID]="organizationID()"
    />
  } @else {
    @switch (document().mimeType) {
      @case ('application/pdf') {
        <iframe
          class="flex-1 w-full h-full"
          [src]="document().id | fileSignedUrl: organizationID() | resourceUrl"
        ></iframe>
      }
      @case ('text/csv') {
        <app-document-csv-table
          class="w-full h-full overflow-auto"
          [document]="document()"
          [organizationID]="organizationID()"
        />
      }
      @default {
        <app-document-icon [file]="document()" [size]="128" />
        <p class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm leading-6">
          {{ 'cockpit.documents.previewDialog.unsupportedFileType' | transloco }}
        </p>
        <app-document-download-button [document]="document()" [organizationID]="organizationID()">
          <ui-button mode="outlined" expand="full" type="button">
            <ng-icon name="heroArrowDownTray" size="20" slot="start" class="!block" />
            {{ 'cockpit.documents.previewDialog.download' | transloco }}
          </ui-button>
        </app-document-download-button>
      }
    }
  }
</div>
